import React, { PropsWithChildren } from 'react'
import { createContext } from 'lib/createContext'
import { parseErrorMessage } from 'api'
import { useCreateCustomShiftNotificationMutation } from 'queries/shifts'
import { useShiftDetailContextValue } from '../../../context/ShiftDetailProvider'

type CreateCustomShiftNotificationFlowContextState = {
  state: {
    mutationState: {
      isPending: boolean
      isError: boolean
      errorMessage: string | undefined
    }
  }
  actions: {
    submit: ReturnType<
      typeof useCreateCustomShiftNotificationMutation
    >['mutate']
    reset: ReturnType<typeof useCreateCustomShiftNotificationMutation>['reset']
  }
}

const [Context, useCreateCustomShiftNotificationFlowContextValue] =
  createContext<CreateCustomShiftNotificationFlowContextState>({
    name: 'CreateCustomShiftNotificationFlowContext',
  })

export const CreateCustomShiftNotificationFlowProvider = ({
  children,
}: PropsWithChildren) => {
  const {
    state: { id: shiftId },
  } = useShiftDetailContextValue()

  const { mutate, isPending, isError, error, reset } =
    useCreateCustomShiftNotificationMutation(shiftId)

  const value: CreateCustomShiftNotificationFlowContextState = {
    state: {
      mutationState: {
        isPending,
        isError,
        errorMessage: parseErrorMessage(error),
      },
    },
    actions: {
      submit: mutate,
      reset,
    },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useCreateCustomShiftNotificationFlowContextValue }
